var CONSTANTS = require('../utils/constants');
var helperIds = CONSTANTS.helperIds;

function getCsrfFromHelper() {
    try {
        return document.getElementById(helperIds.current).getAttribute('csrf');
    } catch (e) {
        return {};
    }
}

module.exports = getCsrfFromHelper;
